import React, { SyntheticEvent, useEffect, useState } from "react";
import {
	Button
} from "semantic-ui-react";
import "./styles.css";
import UserAccountForm from "./forms/UserAccountForm";
import { useParams } from "react-router-dom";
import User from "../../types/entities/User";
import { getUserById } from "../../services/users.service";
import UserPersonForm from "./forms/UserPersonForm";
import PageHeader from "../../components/PageHeader";
import UpdatePasswordModal from "./modals/UpdatePasswordModal";
import RootTemplate from "../../components/RootTemplate";

const UsersForm = () => {

	const [ user, setUser ] = useState<User | null>(null);
	const [ openModal, setOpenModal ] = useState(false);

	const { userId } = useParams();

	const fetchUserById = async (id: string | undefined) => {
        try {

			if (!id) {
				throw new Error("El prospecto no puede ser undefined.");
			}

            const response = await getUserById(id);
            if (response?.status === 200) {
                setUser(response.data);
            } else {
                throw new Error("Error al obtener el usuario");
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchUserById(userId);
    }, [userId]);

	const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

	return (
		<RootTemplate>
		
			<PageHeader
				title="Formulario de usuario"
				actionComponents={
					<Button floated="right" color="blue" align="right" onClick={() => setOpenModal(true)}>
						Actualizar contraseña
					</Button>
				}
			/>

			<UserAccountForm 
				userId={user?.id}
				user={user}
				setUser={setUser}
			/>

			<UserPersonForm 
				userId={user?.id}
				user={user}
				setUser={setUser}
			/>

			<UpdatePasswordModal 
				userId={user?.id || ""}
				openModal={openModal} 
				onClose={handleCancelModal} 
			/>

		</RootTemplate>
	);
};

export default UsersForm;
